import Vue from 'vue'

/**
 * Запрет отрицательных значений в числовых полях.
 *
 * Раньше в «Кол-во аппаратов» и «Кол-во гидов сопровождающих» спокойно
 * вводилось -2: правило проверки только подсвечивало поле красным, а стрелка
 * счётчика уводила ниже нуля молча. Правило подсказывает, но не мешает —
 * значит нужно не давать ввести вовсе.
 *
 * Директива вешается на v-text-field: сама находит внутри input, блокирует
 * минус, плюс и «e» на вводе, вырезает их при вставке и подтягивает значение
 * к нулю. После правки сообщаем полю событием input, иначе v-model не узнает
 * об изменении.
 *
 * Применение:  <v-text-field v-non-negative type="number" ... />
 */
const BAD_KEYS = ['-', '+', 'e', 'E']

// Отрицательное превращаем в ноль, а не в то же число без минуса: стрелка
// счётчика вниз от нуля должна упираться в ноль, а не прыгать на единицу.
//
// Ведущие нули убираем: в полях количества стоит 0, и набранное поверх него
// «10» превращалось в «010». Одинокий ноль оставляем — поле не должно пустеть,
// пока в нём печатают. Всё остальное оставляем как набрано: лишнее
// переформатирование на лету только мешает.
const fixValue = raw => {
  const text = String(raw === undefined || raw === null ? '' : raw)
  if (text === '') return ''
  const num = Number(text)
  if (Number.isNaN(num)) return ''
  if (num < 0) return '0'

  return text.replace(/^0+(?=\d)/, '')
}

const clamp = input => {
  const fixed = fixValue(input.value)
  if (input.value !== fixed) {
    // eslint-disable-next-line no-param-reassign
    input.value = fixed
    input.dispatchEvent(new Event('input', { bubbles: true }))
  }
}

Vue.directive('non-negative', {
  inserted(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (!input) return

    input.setAttribute('min', '0')

    input.addEventListener('keydown', event => {
      if (BAD_KEYS.includes(event.key)) event.preventDefault()
    })
    input.addEventListener('paste', () => setTimeout(() => clamp(input), 0))
    input.addEventListener('input', () => clamp(input))
    input.addEventListener('blur', () => clamp(input))
  },
})

export default fixValue
